export default __webpack_public_path__ + "static/media/posco.b2a113cb.jpg";